export const toCapitalize = (text) => {
  console.log(text)
  if (!text) return ''

  return text.charAt(0).toUpperCase() + text.slice(1)
}
